import CircularProgressbar from "./CircularProgressbar";
import * as React from "react";
import styles = require("./style.less");

interface GettingStartedProgressProps {
    percent: number;
    enabled: boolean;
    header: string;
    imgSrc: string;
}

const GettingStartedProgress: React.StatelessComponent<GettingStartedProgressProps> = props => <div className={styles.progressWrapper}>
        {props.percent === 100 && <div className={styles.complete}><i className="fa fa-check" aria-hidden="true"/></div>}
        <div className={styles.progressContainer}>
            <CircularProgressbar
                percentage={props.percent}
                strokeWidth={6}
                image={props.imgSrc}
            />
        </div>
        <div className={styles.title}>{props.header}</div>
    </div>;

export default GettingStartedProgress;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/GettingStarted/GettingStartedProgress.tsx